module.exports = __webpack_public_path__ + "static/media/pickup_blue.c4e1728d.svg";